/**
 * Sends logs nowhere.
 */
export const nullStream = () => { };
//# sourceMappingURL=nullStream.js.map